var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category"},[_c('h3',{staticClass:"text-center category-head"},[_vm._v(_vm._s(_vm.category[0]))]),_vm._v(" "),_vm._l((_vm.category[1]),function(item,index){return _c('karte-item',{key:index,staticClass:"item",attrs:{"index":index,"item":item}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d84a925a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/karte/KarteCategory.vue
// module id = 68
// module chunks = 0